import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ThosCartState from "@thos/Store/Data/Checkout/ThosCartState";
import ThosSubmitForApprovalState from "@thos/Store/Data/Checkout/ThosSubmitForApprovalState";
import { Draft } from "immer";

const initialState: ThosSubmitForApprovalState = {
    poNumber: "",
    poNumberError: ""
};

const reducer = {
    "Custom/Checkout/SubmitForApproval/SetPoNumber": (
        draft: Draft<ThosSubmitForApprovalState>,
        action: { poNumber: string }) => {
        draft.poNumber = action.poNumber;
    },
    "Custom/Checkout/SubmitForApproval/SetPoNumberError": (
        draft: Draft<ThosSubmitForApprovalState>,
        action: { poNumberError: string }) => {
        draft.poNumberError = action.poNumberError;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
